import { render, staticRenderFns } from "./BaseMultiSelectSearch.vue?vue&type=template&id=894dd5d4"
import script from "./BaseMultiSelectSearch.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelectSearch.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiSelectSearch.vue?vue&type=style&index=0&id=894dd5d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports